import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectUserCognitoGroups } from "../Users/usersSlice";
import { CognitoUserGroups } from "../Users/userUtils";

type ProtectedRouteProps = {
  requiredPermissions: CognitoUserGroups[];
  children?: JSX.Element;
};

export const ProtectedRoute = ({
  requiredPermissions,
  children
}: ProtectedRouteProps) => {
  const permissions = useAppSelector(selectUserCognitoGroups);
  if (
    !permissions?.some((permission) => requiredPermissions.includes(permission))
  ) {
    return <Navigate to={"/"} replace />;
  }
  return children ? children : <Outlet />;
};
